import { render, staticRenderFns } from "./review-detail-modal.vue?vue&type=template&id=6b032f22&scoped=true&"
import script from "./review-detail-modal.vue?vue&type=script&lang=js&"
export * from "./review-detail-modal.vue?vue&type=script&lang=js&"
import style0 from "./review-detail-modal.vue?vue&type=style&index=0&id=6b032f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b032f22",
  null
  
)

export default component.exports